export default __webpack_public_path__ + "static/media/Sustainable fashion chain_mobile.83e6a602.svg";